var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStage5Top(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_44155",
    "data-name": "Group 44155",
    xmlns: "http://www.w3.org/2000/svg",
    width: 195.934,
    height: 217.93,
    viewBox: "0 0 195.934 217.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9564",
    "data-name": "Path 9564",
    d: "M189.087,210.252c-.46,1.623-.86,6.216-1.5,12.172-.568,5.35-6.042,25.252-6.616,27.264-3.608,12.729-11.436,23.386-19.534,24.63-9.18,1.412-24.938,5.171-30.667,11.154-.119.124-.233.254-.346.389-5,6-7.227,16.012-18.09,17.2-10.868-1.184-13.1-11.2-18.1-17.2-.113-.135-.232-.271-.362-.4-5.734-5.972-21.476-9.732-30.65-11.143-8.1-1.244-15.931-11.377-19.539-24.111a53.7,53.7,0,0,1-1.379-6.183c-.573-3.538-4.663-16.256-5.231-21.6-.639-5.956-1.044-10.549-1.5-12.172-.773-2.732,37.483.336,76.762,4.182,39.274-3.846,77.524-6.914,76.751-4.182",
    transform: "translate(-14.47 -85.134)",
    fill: "#d3b1a7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9565",
    "data-name": "Path 9565",
    d: "M186.654,227.085l-5.139,17.581s-2.705,9.467-4.6,14.336-15.958,13.794-19.745,19.474-13.594,9.315-23.023,14.26c-.39.206-.8.395-1.239.573-4.241,1.737-10.743,2.385-16.9,2.553-6.161-.168-12.664-.817-16.9-2.553-.438-.179-.849-.368-1.239-.573-9.429-4.944-19.236-8.579-23.023-14.26S56.987,263.87,55.093,259s-4.6-14.336-4.6-14.336l-5.139-17.581L116,232.922Z",
    transform: "translate(-18.457 -92.408)",
    fill: "#efcabf"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9566",
    "data-name": "Path 9566",
    d: "M191.2,84.343C183.332,35,156.343.044,106.377.044h-.007C105.5.018,104.636,0,103.761,0,53.8,0,26.806,34.959,18.933,84.3c-5.661,35.478,7.636,60.036,30.113,76.222,4.208,3.03,10.723,5.14,17.13,6.939,10.28,6.5,18.186,11.853,36.38,12.508.2.008.394.013.594.017,1.054.031,2.132.052,3.257.052a26.473,26.473,0,0,0,3.394-.216c16.5-.988,24.182-6.09,33.919-12.252,6.485-1.813,13.11-3.938,17.372-7.007,22.477-16.186,35.774-40.744,30.113-76.222",
    transform: "translate(-7.176 -0.001)",
    fill: "#060606"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9567",
    "data-name": "Path 9567",
    d: "M300.463,197.891s11.749-6.35,11.749,0-10.819,19.138-14.065,24.1-12.4,7.646-12.4,7.646Z",
    transform: "translate(-116.278 -79.38)",
    fill: "#e5bfb1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9568",
    "data-name": "Path 9568",
    d: "M11.749,190.594S0,184.244,0,190.594s10.819,19.138,14.065,24.1,12.4,7.646,12.4,7.646Z",
    transform: "translate(0 -76.411)",
    fill: "#e5bfb1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9569",
    "data-name": "Path 9569",
    d: "M171.552,193.136c-3.348-2.28-4.978.39-6.094,5.7-.314.008-.589.446-.807,1.477-2.075,9.827-6.137,44.363-45.134,45.857S71.9,196.022,71.9,196.022s-.176.262-.462.707c-1.121-5.8-2.743-8.828-6.245-6.443-12.162,8.281-11.185,39.073-11.185,39.073L72.675,248.1s1.766.592,4.38,1.438c5.667,8.2,10.787,14.543,10.787,14.543l32.021,7.3c17.225,3.928,31.528-7.759,41.075-19.4,1.91-.624,3.131-1.032,3.131-1.032l18.668-18.745s.977-30.793-11.185-39.073",
    transform: "translate(-21.97 -77.1)",
    fill: "#efcabf"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9570",
    "data-name": "Path 9570",
    d: "M211.55,79.62c0,16.51-16.881,29.892-37.7,29.892s-37.7-13.382-37.7-29.892,16.881-29.892,37.7-29.892,37.7,13.382,37.7,29.892",
    transform: "translate(-73.389 -45.811)",
    fill: "#efcabf"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11605",
    "data-name": "Path 11605",
    d: "M-13074.151-1060.765s13.616-30.121,38.617-29.136,22.837,6.13,29.929,17.1,16.4,14.641,26.381,0,11.7-13.863,19.87-15.074,38.849,7.961,43.5,19.275-30.608,45.919-30.608,45.919l-91.833,4.659-27.834-26.8-4.125-6.095Z",
    transform: "translate(13095.242 1195.441)",
    fill: "#efcabf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStage5Top);
export default __webpack_public_path__ + "static/media/stage5_top.84ab386614b6ab12fd9407dcd843ab41.svg";
export { ForwardRef as ReactComponent };